import { useCampaign } from "@/components/apis/campaign";
import CampaignContent from "@/components/campaign/campaign-content";

export default function CampaignPage() {
    return (
        <div className=" mx-auto pt-20">
            <div className="md:my-10 ">

                <div className="flex flex-col item-start md:items-center gap-2.5 mx-4 md:ml-0">
                    <div className="text-white text-[28px] md:text-[40px] font-medium md:leading-[48px] leading-[36px]">
                        Campaign{" "}
                    </div>
                    <div className=" md:text-center text-zinc-500 text-sm md:text-base font-normal leading-normal">
                        Check out Holdstation&apos;s latest campaigns for unique opportunities
                        and special benefits.{" "}
                    </div>
                </div>

            </div>
            <Body />
        </div>
    );
}

function LoadingComponent() {
    return <div>Loading...</div>;
}

export function Body() {
    const { data, error, isLoading } = useCampaign()

    // TODO: show loading state + error state
    if (error) {
        return null;
    }

    return (
        <>
            <div >
                {isLoading ? <LoadingComponent /> : <CampaignContent data={data ?? []} />}
            </div>

            {/* <div className="block md:hidden">
                {isLoading ? <LoadingComponent /> : <ContentMobile data={data ?? []} />}
            </div> */}
        </>
    );
}
